import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import { Toast } from '../components_root/ToastContext';
export const seo = {
    title: "Online Tools & Digital Services | Productivity, SEO & File Conversion",
    description:
        "Explore free and premium online tools including word counters, file converters, favicon generators, SEO analyzers, and text utilities. Improve productivity with powerful digital tools for students, writers, developers, and businesses.",
    keywords:
        "online tools, productivity tools, seo tools, text utilities, file converter, image to pdf, favicon generator, word counter, online utilities, digital tools, website tools",

};
export default function Page_view({ data }) {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    return (
        <div>

            <Helmet key={data?.slug}>
                <title>{data?.page_name || seo.title}</title>

                <meta
                    name="description"
                    content={data?.page_description ? data.page_description : seo.description}
                />

                <meta
                    name="keywords"
                    content={data?.page_keywords ? data.page_keywords : seo.keywords}
                />

                <meta
                    property="og:title"
                    content={data?.page_name ? data.page_name : seo.title}
                />

                <meta
                    property="og:description"
                    content={data?.page_description ? data.page_description : seo.description}
                />

                <meta property="og:url" content={window.location.href} />
            </Helmet>
            <div className="container_roots b-top">
                <div className="container_size">
                    <h2 className="text-xl font-bold mb-4 fcap">{data.page_name}</h2>
                    <div className='post-container'>
                        {data.page_description}
                    </div>

                </div>

            </div>



        </div>
    );
}
